module.exports = __webpack_public_path__ + "img/trial2-3.71d01e3a.png";